module.exports = __webpack_public_path__ + "static/media/KOLsConversion.4595c2ff.png";